import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';

import { SpecialOfferProduct } from '../models/special-offer-product';

export class SupplierSpecialOffersDetailProductsApi {
    constructor(protected baseUrl: string) {}

    public getProducts(
        specialOfferId: number,
        params?: URLSearchParams
    ): Promise<ApiResult<PaginatedResponse<SpecialOfferProduct>>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/supplier-special-offers/${specialOfferId}/products`, { params }),
            response => response.data
        );
    }
}
